import {FC} from 'react'
import {Link} from 'react-router-dom'
import {defineMessages, useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const M = defineMessages({
  systemError: {id: 'common.errorPage.systemError', defaultMessage: 'System error'},
  somethingWentWrong: {
    id: 'common.errorPage.somethingWentWrong',
    defaultMessage: 'Something went wrong! Please try again later.',
  },
  returnHome: {id: 'common.errorPage.returnHome', defaultMessage: 'Return home'},
})

const Error500: FC = () => {
  const intl = useIntl()
  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2qx text-gray-900 mb-4'>
        {intl.formatMessage(M.systemError)}
      </h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-500 mb-7'>
        {intl.formatMessage(M.somethingWentWrong)}
      </div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-11'>
        <img
          src={toAbsoluteUrl('/media/auth/500-error.png')}
          className='mw-100 mh-300px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/auth/500-error-dark.png')}
          className='mw-100 mh-300px theme-dark-show'
          alt=''
        />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className='mb-0'>
        <Link to='/dashboard' className='btn btn-sm btn-primary'>
          {intl.formatMessage(M.returnHome)}
        </Link>
      </div>
      {/* end::Link */}
    </>
  )
}

export {Error500}
